import src from "IMAGE";
export default { src, width: 33, height: 33, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
